export async function handleResponse(response) {
  if (response.status === 200 || response.status === 304) {
    return response;
  }
  switch (response.status) {
    case 400: // bad request
      // So, a server-side validation error occurred.
      // Server side validation returns a string error message, so parse as text instead of json.
      const error = await response.text();
      throw new Error(error);

    case 401: // unauthorized
    case 403: // forbidden
      throw new Error("Auth error");

    default:
      // asssume server went squiffy
      throw new Error("Server error (not your fault!)" + response.status);
  }
}

export async function handleResponsePDF(response) {
  if (response.status === 200) {
    // Convert base64 string back to ArrayBuffer
    const binaryString = atob(response.pdf);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const pdfBlob = new Blob([bytes], { type: "application/pdf" });
    return pdfBlob;
  }

  // Handle other status codes
  switch (response.status) {
    case 400:
      throw new Error(await response.text());
    case 401:
    case 403:
      throw new Error("Auth error");
    default:
      throw new Error("Server error (not your fault!) " + response.status);
  }
}

// In a real app, would likely call an error logging service.
export function handleError(error) {
  // eslint-disable-next-line no-console
  console.error("API call failed. " + error);
  throw error;
}
